import React, { useEffect, useState } from "react";
import AuthCheck from "../components/AuthCheck";
import {
  Button,
  Card,
  Col,
  Container,
  Nav,
  Navbar,
  NavDropdown,
  Row,
  Spinner,
} from "react-bootstrap";
import { Link, Outlet, useLocation, useParams } from "react-router-dom";
import {
  faAddressBook,
  faBarChart,
  faFilm,
  faGear,
  faLineChart,
  faPencil,
  faServer,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import tableDataModules from "../controller/tableDataModules";
import { useTheme } from "../context/ThemeContext";
export default function CaseOverview() {
  let { caseid } = useParams();
  let caseID = caseid;

  const [generating, setGenerating] = useState("");
  const [caseData, setCaseData] = useState(null);
  const { effectiveTheme } = useTheme();
  useEffect(() => {
    console.log(caseID);
    tableDataModules.getCaseData(caseID).then((res) => {
      setCaseData(res);
    });
    setInterval(() => {
      tableDataModules
        .getPendingGenQue()
        .then((res) => {
          setGenerating(res);
        })
        .catch((error) => {});
    }, 3000);
  }, [caseID]);

  return (
    <>
      <AuthCheck />
      <Container fluid={true} style={{ height: "100%" }}>
        <Row style={{ paddingTop: "20px" }}>
          <Navbar
            bg={effectiveTheme === "dark" ? "dark" : "light"}
            variant={effectiveTheme === "dark" ? "dark" : "light"}
          >
            <Navbar.Brand href="/">
              {caseData != null
                ? caseData.module.name + " - " + caseData.name
                : "Loading..."}{" "}
            </Navbar.Brand>
            {generating !== "" ? (
              <Nav.Item>
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
                <span> Generating ....</span>
              </Nav.Item>
            ) : (
              ""
            )}

            <Nav className="me-auto"></Nav>
            <Nav>
              <Nav.Link href="#">
                Deadline:{" "}
                {caseData
                  ? tableDataModules.functionMillisToDate(caseData.deadline)
                  : "..."}
              </Nav.Link>
              <NavDropdown title={<FontAwesomeIcon icon={faGear} />}>
                <NavDropdown.Item href="#">Recalculate</NavDropdown.Item>
                <NavDropdown.Item href="#">Upload rtstruct</NavDropdown.Item>
                <NavDropdown.Item href="#">Show Files</NavDropdown.Item>
                <NavDropdown.Item href="#">Show WADO</NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar>
        </Row>
        <Row style={{ marginTop: "10px", height: "90%" }}>
          <Col xs={{ span: 1 }} className="p-0">
            <Card>
              <Card.Body>
                <div className="d-grid gap-2">
                  <CustomLink
                    href="Students"
                    title={<FontAwesomeIcon icon={faAddressBook} />}
                  />
                  {/*<CustomLink href="GoldenStandard" title="Golden Standard"/>*/}
                  <CustomLink
                    href="Viewer"
                    title={<FontAwesomeIcon icon={faFilm} />}
                  />
                  <CustomLink
                    href="Histogram"
                    title={<FontAwesomeIcon icon={faLineChart} />}
                  />
                  <CustomLink
                    href="Rules"
                    title={<FontAwesomeIcon icon={faServer} />}
                  />
                  <CustomLink
                    href="Edit"
                    title={<FontAwesomeIcon icon={faPencil} />}
                  />
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Outlet context={[caseData, setCaseData]} />
        </Row>
      </Container>
    </>
  );
}

export function CustomLink({ href, title = href }) {
  const path = useLocation().pathname;
  const mypath = path.substr(0, path.indexOf("/", -1)) + href.toLowerCase();
  return (
    <Link to={mypath}>
      <Button
        variant={path.endsWith(mypath) ? "primary" : "outline-primary"}
        className="w-100"
      >
        {title}
      </Button>
    </Link>
  );
}
